<template>
  <el-dialog
    title="创建來源"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose"
    class="dialogEdit"
  >
    <el-form :model="form" label-width="80px">
      <el-form-item label="來源名稱">
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="來源數值">
        <el-input v-model="form.value" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="onSubmit">確 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "compare_dialog",
  data() {
    return {
      dialogVisible: false,
      formLabelWidth: 30,
      form: {
        name: "",
        logo: "",
        status: true
      }
    };
  },

  computed: {
    files() {
        console.log("logo:",this.form.logo);
        if(this.form.logo.length>0)
        {
            return [{url:this.form.logo,name:'logo.jpg'}];
        }else
        {
            return [];
        }
    }
  },
  methods: {
    show(value) {
      this.dialogVisible = true;
      var self = this;
      if (value !== undefined) {
        this.form = Object.assign({}, value);
      } else {
        this.form = { name: "", value: "" };
      }
    },

    onSuccess(image) {
      this.form.logo = image.path;
    },
    onSubmit() {
      var self = this;
      let params = Object.assign({}, this.form);
      this.$http.post("/admin/rsource/edit", params).then(res => {
        self.$emit("sucess");
        this.dialogVisible = false;
      });
    }
  }
};
</script>
<style lang="less">
.dialogEdit {
  text-align: left;
}
</style>